import React, { forwardRef, useState, useEffect } from 'react';
import './Input.scss';

import { HiEyeOff } from 'react-icons/hi';
import { HiEye } from 'react-icons/hi2';
import { FaCalendarDay } from 'react-icons/fa';

export type InputProps = {
    label?: string;
    placeholder: string;
    value: string;
    onValueChange: React.Dispatch<React.SetStateAction<string>> | ((value: string) => void);
    isPassword?: boolean;
    icon?: React.ReactNode;
    iconPosition?: 'left' | 'right';
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
    ({ label, placeholder, value, onValueChange, isPassword = false, icon, iconPosition = 'left', className, ...props }, ref) => {
        const [isPasswordShown, setIsPasswordShown] = useState<boolean>(false);
        const [displayValue, setDisplayValue] = useState<string>('');

        useEffect(() => {
            if (props.type == 'date') {
                const date = new Date(value);
                setDisplayValue(
                    date.toLocaleDateString('fr-FR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: '2-digit'
                    })
                );
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [value]);

        return (
            <div className={`input-wrapper ${className} ${isPassword ? 'password-wrapper' : ''}`}>
                {label && <label>{label}</label>}
                <div className="input-container">
                    {icon && iconPosition === 'left' && <div className="icon-container icon-left">{icon}</div>}
                    <input
                        type={!isPassword || isPasswordShown ? 'text' : 'password'}
                        placeholder={isPassword && !isPasswordShown ? '**********' : placeholder}
                        value={value}
                        onChange={(e) => {
                            onValueChange(e.target.value);
                        }}
                        className={`${className} ${value.length ? 'has-value' : ''}`}
                        display-value={displayValue}
                        ref={ref}
                        {...props}
                    />
                    {props.type === 'date' && <FaCalendarDay />}
                    {icon && iconPosition === 'right' && <div className="icon-container icon-right">{icon}</div>}
                    {isPassword && !isPasswordShown && (
                        <HiEye
                            onClick={() => {
                                setIsPasswordShown(true);
                            }}
                        />
                    )}
                    {isPassword && isPasswordShown && (
                        <HiEyeOff
                            onClick={() => {
                                setIsPasswordShown(false);
                            }}
                        />
                    )}
                </div>
            </div>
        );
    }
);
